import React, { Fragment, useEffect, useRef, useState } from "react";
import { Button, Col, Input, Row, Table } from "reactstrap";
import _ from "lodash";
import { useParams } from "react-router-dom";
import { api, constants, dateHelpers } from "../utils";
import { DesktopContainer } from "../layouts";
import axios from "axios";
import { toast } from "react-toastify";
import Select from "react-select";
//import { CountrySelect, StateRegionSelect } from ".";

const cancelToken = axios.CancelToken;
const ErrorMessage = "Something went wrong while loading the data, please try again or contact an admin";
//const newThirdPartyAddress = {
//   description: "",
//   adrscode: "",
//   companyName: "",
//   contactName: "",
//   addressLine1: "",
//   addressLine2: { label: "", value: "-1" },
//   city: "",
//   state: "",
//   zip: "",
//   country: { label: "United States", value: "United States" },
//   countryCode: "US",
//   phone: "",
//   fax: "",
//   isThirdPartyAddress: true
//};
const source = cancelToken.source();
const ThirdPartyAddress = {
   ThirdPartyAddress1: "",
   ThirdPartyAddress2: "",
   ThirdPartyCity: "",
   ThirdPartyCompanyName: "",
   ThirdPartyContactName: "",
   ThirdPartyFax: "",
   ThirdPartyPhone: "",
   ThirdPartyZipCode: "",
   ThirdPartyDescription: "",
}
const TYPE_OF_ORDER = {
   ConsignedOrder: {
      id: 2,
      text: "Print bill of lading for this consigned order",
   },
   SOPOrder: {
      id: 1,
      text: "Check the orders you would like to be combined into one bill of lading.",
   },
};
const MASTER_SELECT = "3RDPARTY";

export default function BillOfLading(props) {
   const { id } = useParams();
   const [addressList, setAddressList] = useState([]);
   const [addressSelectValue, setAddressSelectValue] = useState(null);
   const [buttonText, setButtonText] = useState("Reprint Bill of Lading");
   const [checkList, setCheckList] = useState([]);
   const [currentBillOfLading, setCurrentBillOfLading] = useState(null);
   const [data, setData] = useState([]);
   const [formLists, setFormLists] = useState({
      countryList: [],
      stateList: [],
   });
   const [fullAddressList, setFullAddressList] = useState([]);
   const isMounted = useRef(true);
   const [order, setOrder] = useState(null);
   //const [saveOrUpdateThirdPartyAddress, setSaveOrUpdateThirdPartyAddress] = useState(true);
   const [thirdPartyBilling, setThirdPartyBilling] = useState(false);
   const [tpbAddress, setTPBAddressSelectValue] = useState(null);
   //const ExistingGPAdress = addressSelectValue ? _.startsWith(addressSelectValue.value, "OTHER") : false;
   const IsSOPOrder = order?.orderType === TYPE_OF_ORDER.SOPOrder.id;
   const saveOrUpdateThirdPartyAddress = true;
   let alreadyDisplayedList = [];

   useEffect(() => {
      if (thirdPartyBilling && addressList && addressList.length) {
         let selectedAddress = (currentBillOfLading) 
            ? _.find(addressList, adr => adr.value === currentBillOfLading.thirdPartyAddressCode)
            : _.find(addressList, adr => adr.value === MASTER_SELECT);

         if (selectedAddress) {
            setAddressSelectValue(selectedAddress);
            let addressInfo = _.find(fullAddressList, adr => adr.adrscode === selectedAddress.value);
            setTPBAddressSelectValue(addressInfo);
         }
         else {
            toast.warning("No 3rd Party address exists. Please contact customer service.");
         }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [addressList]);

   useEffect(() => {
      _.forEach(data, (x => {
         if (x.sopNumber === order.orderId) {
            let copy = checkList.slice();
            copy.push(x.sopNumber);
            setCheckList(copy);
         }
      }))
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [data]);

   useEffect(() => {
      if (thirdPartyBilling && addressList && addressList.length) {
         let selectedAddress = (currentBillOfLading)
            ? _.find(addressList, adr => adr.value === currentBillOfLading.thirdPartyAddressCode)
            : _.find(addressList, adr => adr.value === MASTER_SELECT);

         if (selectedAddress) {
            setAddressSelectValue(selectedAddress);
            let addressInfo = _.find(fullAddressList, adr => adr.adrscode === selectedAddress.value);
            setTPBAddressSelectValue(addressInfo);
         }
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [fullAddressList]);

   useEffect(() => {
      const cancelToken = axios.CancelToken;
      const source = cancelToken.source();
      if (id && !_.isEmpty(id)) {
         const json = decodeURI(id);
         const obj = JSON.parse(json);
         if (obj) setOrder(obj);

         if (obj.orderId) {
            //Load the states and the current bill of lading
            function LoadStates() {
               return api.fetchS(`Reference/GetStateCountryLists`);
            }
            function LoadCurrentBillOfLading() {
               return api.fetchS(
                  `Order/GetBillOfLadingByOrderNumber/${obj.orderId}`
               );
            }
            Promise.all([LoadStates(), LoadCurrentBillOfLading()])
               .then((res) => {
                  if (!res[0].data.success || !res[1].data.success) {
                     toast.error(
                        "Something went wrong while loading the data, please try again or contact an admin"
                     );
                     for (let mes of res) {
                        if (mes.data.message) {
                           throw new Error(mes.data.message);
                        }
                     }
                     return;
                  }
                  if (isMounted.current) {
                     let copy = { ...formLists };
                     _.map(res[0].data, (value, key) => {
                        if (key === "countries") {
                           copy.countryList = _.map(value, (x) => {
                              return { value: x.id, label: x.text };
                           });
                        } else if (key === "state") {
                           copy.stateList = _.map(value, (x) => {
                              return { value: x.id, label: x.name };
                           });
                        }
                     });
                     setCurrentBillOfLading(res[1].data.BillOfLading);
                     setFormLists(copy);
                     PageLoad(obj.orderType, obj.orderId);
                  }
               })
               .catch((error) => {
                  api.catchHandler(error);
                  toast.error(ErrorMessage);
               });
         }
      }

      return () => {
         isMounted.current = false;
         source.cancel("axios request cancelled");
      };
      // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [id]);

   function handleCheck(orderNumber, checked) {
      let copy = checkList.slice();
      if (checked) {
         copy.push(orderNumber);
         setCheckList(copy);
      } else {
         let newArr = copy.filter(function (value, index, arr) {
            return value !== orderNumber;
         });
         setCheckList(newArr);
      }
   }

   function onChangeThirdPartyAddress(field, value) {
      // Currently all inputs are disabled and this is not called
      if (!tpbAddress) return;
      let copy = Object.assign({}, tpbAddress);
      copy[field] = value;
      setTPBAddressSelectValue(copy);
   }

   async function PageLoad(orderType, orderId) {
      async function LoadSOPOrderFormValues() {
         let payload = {
            OrderId: orderId,
            OrderType: orderType,
         };
         await api
            .postS(`Order/LoadSOPOrderFormValues`, payload, source.token)
            .then(async (res) => {
               if (!res.data.success) {
                  toast.error(ErrorMessage);
                  throw new Error(res.data?.message);
               }
               setButtonText(res.data?.vm.buttonText);
               let list = _.orderBy(res.data?.vm.relatedOrders, x => x.sopNumber, "DESC")
               setData(list);
               setThirdPartyBilling(res.data?.vm?.thirdPartyBilling);
               setAddressList(res.data?.vm?.addressList);
               setFullAddressList(res.data?.vm?.fullAddressList);
            })
            .catch(api.catchHandler);
      }

      async function LoadConsignedBillOflading() {
         let payload = {
            OrderId: orderId,
            OrderType: orderType,
         };
         await api
            .postS(`Order/LoadConsignedBillOflading`, payload, source.token)
            .then(async (res) => {
               if (!res.data.success) {
                  toast.error(ErrorMessage);
                  throw new Error(res.data?.message);
               }
               setButtonText(res.data?.vm.buttonText);
               setThirdPartyBilling(res.data?.vm?.thirdPartyBilling);
               setAddressList(res.data?.vm?.addressList);
               setFullAddressList(res.data?.vm?.fullAddressList);
            })
            .catch(api.catchHandler);
      }

      if (orderType === TYPE_OF_ORDER.SOPOrder.id) {
         await LoadSOPOrderFormValues();
      } else {
         await LoadConsignedBillOflading();
       }
   }

   async function ReprintBillOfLading() {
      let payload = {
         OrderId: order?.orderId,
         OrderType: order?.orderType,
         SOPNumbers: checkList
      };

      if (currentBillOfLading !== null) {
         payload.SOPNumbers = _.uniq(alreadyDisplayedList);
      }

      if (thirdPartyBilling) {
         ThirdPartyAddress.ThirdPartyAddress1 = tpbAddress?.addressLine1;
         ThirdPartyAddress.ThirdPartyAddress2 = tpbAddress?.addressLine2;
         ThirdPartyAddress.ThirdPartyCity = tpbAddress?.city;
         ThirdPartyAddress.ThirdPartyCompanyName = tpbAddress?.companyName;
         ThirdPartyAddress.ThirdPartyContactName = tpbAddress?.contactName;
         ThirdPartyAddress.ThirdPartyFax = tpbAddress?.fax;
         ThirdPartyAddress.ThirdPartyPhone = tpbAddress?.phone;
         ThirdPartyAddress.ThirdPartyZipCode = tpbAddress?.zip;
         ThirdPartyAddress.ThirdPartyDescription = tpbAddress?.description;
         ThirdPartyAddress.ThirdPartyCountry = tpbAddress?.country;
         ThirdPartyAddress.ThirdPartyState = tpbAddress?.state;
         Object.assign(payload, ThirdPartyAddress);
         payload.isCountryUS = tpbAddress?.country === "United States";
         payload.ThirdPartyAddressSelect = addressSelectValue?.value;
         payload.ThirdPartyBilling = thirdPartyBilling;
         payload.UpdateAddress = saveOrUpdateThirdPartyAddress;
      }

      if (payload.ThirdPartyCountry === "United States") {
         payload.Country = "US";
      }

      function CreateSOPBillOfLading() {
         if (payload.SOPNumbers.length === 0) {
            toast.error("Please select an order for the BOL report.");
            return;
         }

         api
            .postDownloadBinary(
               `Report/CreateSOPBillOfLading`,
               payload,
               constants.MIME_TYPES.pdf,
               `BOL ${order?.orderId} ${dateHelpers.toLongDateString(dateHelpers.monthDayAndYear(Date.now()))}.pdf`
            )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
            })
            .catch(api.catchHandler);
      }

      function PrintConsignedBillOfLading() {
         api
            .postDownloadBinary(
               `Report/PrintConsignedBillOfLading`,
               payload,
               constants.MIME_TYPES.pdf,
               `BOL ${order?.orderId} ${dateHelpers.toLongDateString(dateHelpers.monthDayAndYear(Date.now()))}.pdf`
            )
            .then((res) => {
               if (res?.data === false) {
                  toast.error(res.message);
               }
            })
            .catch(api.catchHandler);
      }

      if (order?.orderType === TYPE_OF_ORDER.SOPOrder.id) {
         await CreateSOPBillOfLading();
      } else {
         await PrintConsignedBillOfLading();
      }
   }

   function updateThirdPartyAddress(newAddress) {
      setAddressSelectValue(newAddress);
      let selectedAddress = _.find(fullAddressList, adr => adr.adrscode === newAddress.value);
      if (selectedAddress) {
         let copy = Object.assign({}, selectedAddress);
         //copy.country = copy.country ? { label: copy.country, value: copy.country } : null;
         //copy.state = copy.state ? _.find(constants.STATE_LIST, st => st.value.toLowerCase() === copy.state.toLowerCase()) : null;
         setTPBAddressSelectValue(copy);
      }
      //else if (newAddress.value === "-2") {
      //   let copy = Object.assign({}, newThirdPartyAddress);
      //   setTPBAddressSelectValue(copy);
      //}
      else {
         setTPBAddressSelectValue(null);
      }
   }

   return (
      <DesktopContainer screenName={"Bill of Lading"}>
         <div className="filter-header mb-3">
            <h5 className="ms-5" style={{ color: "white" }}>
               {IsSOPOrder
                  ? TYPE_OF_ORDER.SOPOrder.text
                  : TYPE_OF_ORDER.ConsignedOrder.text}
            </h5>
            <Row className="ms-5 mt-2">
               <Col className="p-0">
                  <Button className="shredButton" children={buttonText} onClick={ReprintBillOfLading} disabled={_.isEmpty(data) && IsSOPOrder} />
               </Col>
            </Row>
         </div>
         <div>
            {"ORDER ID: " + order?.orderId} <br />
            {IsSOPOrder ? 'ORDER TYPE: Sales Order' : order?.orderType === TYPE_OF_ORDER.ConsignedOrder.id ? 'ORDER TYPE: Consigned Order' : 'ORDER TYPE:'}
            {/*{"ORDER TYPE: " + order?.orderType + ` ${typeof order?.orderType}`}{" "}*/}
            <br />
            {!_.isEmpty(data) && (
               <Table size="sm" className="data-table">
                  <thead className="table-header">
                     <tr>
                        <th colSpan={1} />
                        <th>Order Number</th>
                        <th>Customer</th>
                        <th>Customer P/N</th>
                        <th>Item</th>
                        <th><span>Qty<br />Ordered</span></th>
                        <th><span>Qty<br />Applied</span></th>
                        <th><span>Qty<br />Avail</span></th>
                        <th><span>Qty<br />Rem</span></th>
                        <th>Frieght Carrier</th>
                     </tr>
                  </thead>
                  <tbody>
                     {_.map(data, (item, indexNumber) => {
                        let alreadyDisplayed = _.includes(alreadyDisplayedList, item.sopNumber);
                        alreadyDisplayedList.push(item.sopNumber);
                        return (
                           <tr
                              key={`abc-${indexNumber}`}
                              className={`tr-${indexNumber % 2 === 0 ? "primary" : "secondary"}`}
                           >
                              {
                                 alreadyDisplayed ? <td /> :
                                    <td style={{ paddingLeft: "15px" }}>
                                       <input type="checkbox"
                                          checked={_.includes(checkList, item.sopNumber) ? true : false}
                                          onChange={(e) => handleCheck(item.sopNumber, e.target.checked)}
                                       />
                                    </td>
                              }
                              {alreadyDisplayed ? <td /> : <td>{item.sopNumber}</td>}
                              <td>{item.customerNumber + " | " + item.customerName}</td>
                              <td>{item.asiCustomerItemNumber}</td>
                              <td>{item.itemNumber}</td>
                              <td>{item.quantityRemaining}</td>
                              <td>{item.quantityFulfilled}</td>
                              <td>{item.quantityAvailable}</td>
                              <td>{item.quantityToBeAllocatedOrReceived}</td>
                              <td>{item.shippingMethod}</td>
                           </tr>
                        );
                     })}
                  </tbody>
               </Table>
            )}
            {thirdPartyBilling && addressList && addressList.length
               ? (
                  <Fragment>
                     <Row className="ms-5 mt-2">
                        <Col xs="3" >Select Address: </Col>
                        <Select
                           classNamePrefix="serviceThreadSelect"
                           id="thirdPartyAddress"
                           options={addressList}
                           value={addressSelectValue}
                           onChange={updateThirdPartyAddress}
                           isClearable
                        />
                     </Row>
                  </Fragment>
               )
               : null}
            {thirdPartyBilling && tpbAddress
               ? (
                  <Fragment>
                     <Row className="ms-5 mt-2">
                        <Col xs="4" className="fw-bold">Third Party Billing Information</Col>
                     </Row>
                     <Row className="ms-5 mt-2">
                        <Col xs="4" className="fw-bold">Description:</Col>
                        <Col>
                           <Input
                              value={tpbAddress?.description}
                              disabled={true}
                              //disabled={tpbAddress?.isThirdPartyAddress === false || ExistingGPAdress}
                              onChange={(e) => onChangeThirdPartyAddress("description", e.target.value)}
                           />
                        </Col>
                     </Row>
                     <Row className="ms-5 mt-2">
                        <Col xs="4" className="fw-bold">Company Name:</Col>
                        <Col>
                           <Input
                              value={tpbAddress?.companyName}
                              disabled={true}
                              //disabled={tpbAddress?.isThirdPartyAddress === false || ExistingGPAdress}
                              onChange={(e) => onChangeThirdPartyAddress("companyName", e.target.value)}
                           />
                        </Col>
                     </Row>
                     <Row className="ms-5 mt-2">
                        <Col xs="4" className="fw-bold">Contact Name:</Col>
                        <Col>
                           <Input
                              value={tpbAddress?.contactName}
                              disabled={true}
                              //disabled={tpbAddress?.isThirdPartyAddress === false || ExistingGPAdress}
                              onChange={(e) => onChangeThirdPartyAddress("contactName", e.target.value)}
                           />
                        </Col>
                     </Row>
                     <Row className="ms-5 mt-2">
                        <Col xs="4" className="fw-bold">Address Line 1:</Col>
                        <Col>
                           <Input
                              value={tpbAddress?.addressLine1}
                              disabled={true}
                              //disabled={tpbAddress?.isThirdPartyAddress === false || ExistingGPAdress}
                              onChange={(e) => onChangeThirdPartyAddress("addressLine1", e.target.value)}
                           />
                        </Col>
                     </Row>
                     <Row className="ms-5 mt-2">
                        <Col xs="4" className="fw-bold">Address Line 2:</Col>
                        <Col>
                           <Input
                              value={tpbAddress?.addressLine2}
                              disabled={true}
                              //disabled={tpbAddress?.isThirdPartyAddress === false || ExistingGPAdress}
                              onChange={(e) => onChangeThirdPartyAddress("addressLine2", e.target.value)}
                           />
                        </Col>
                     </Row>
                     <Row className="ms-5 mt-2">
                        <Col xs="4" className="fw-bold">City:</Col>
                        <Col>
                           <Input
                              value={tpbAddress?.city}
                              disabled={true}
                              //disabled={tpbAddress?.isThirdPartyAddress === false || ExistingGPAdress}
                              onChange={(e) => onChangeThirdPartyAddress("city", e.target.value)}
                           />
                        </Col>
                     </Row>
                     <Row className="ms-5 mt-2">
                        <Col xs="4" className="fw-bold">Country:</Col>
                        <Col>
                           <Input
                              value={tpbAddress?.country}
                              disabled={true}
                              onChange={(e) => onChangeThirdPartyAddress("country", e.target.value)}
                           />
                           {/*<CountrySelect*/}
                           {/*   disabled={tpbAddress?.isThirdPartyAddress === false}*/}
                           {/*   value={tpbAddress?.country}*/}
                           {/*   onChangeCallback={(e) => onChangeThirdPartyAddress("country", e)}*/}
                           {/*/>*/}
                        </Col>
                     </Row>
                     <Row className="ms-5 mt-2">
                        <Col xs="4" className="fw-bold">State/Region:</Col>
                        <Col>
                           <Input
                              value={tpbAddress?.state}
                              disabled={true}
                              onChange={(e) => onChangeThirdPartyAddress("state", e.target.value)}
                           />
                           {/*<StateRegionSelect*/}
                           {/*   disabled={tpbAddress?.isThirdPartyAddress === false}*/}
                           {/*   value={tpbAddress?.state}*/}
                           {/*   onChangeCallback={(e) => onChangeThirdPartyAddress("state", e)}*/}
                           {/*/>*/}
                        </Col>
                     </Row>
                     <Row className="ms-5 mt-2">
                        <Col xs="4" className="fw-bold">Zip/Postal Code:</Col>
                        <Col>
                           <Input
                              value={tpbAddress?.zip}
                              disabled={true}
                              //disabled={tpbAddress?.isThirdPartyAddress === false || ExistingGPAdress}
                              onChange={(e) => onChangeThirdPartyAddress("zip", e.target.value)}
                           />
                        </Col>
                     </Row>
                     <Row className="ms-5 mt-2">
                        <Col xs="4" className="fw-bold">Phone #:</Col>
                        <Col>
                           <Input
                              value={tpbAddress?.phone}
                              disabled={true}
                              //disabled={tpbAddress?.isThirdPartyAddress === false || ExistingGPAdress}
                              onChange={(e) => onChangeThirdPartyAddress("phone", e.target.value)}
                           />
                        </Col>
                     </Row>
                     <Row className="ms-5 mt-2">
                        <Col xs="4" className="fw-bold">Fax #:</Col>
                        <Col>
                           <Input
                              value={tpbAddress?.fax}
                              disabled={true}
                              //disabled={tpbAddress?.isThirdPartyAddress === false || ExistingGPAdress}
                              onChange={(e) => onChangeThirdPartyAddress("fax", e.target.value)}
                           />
                        </Col>
                     </Row>
                     {/*{tpbAddress?.isThirdPartyAddress*/}
                     {/*   ? (*/}
                     {/*      <Row className="ms-5 mt-2">*/}
                     {/*         <Col xs="1">*/}
                     {/*            <Input*/}
                     {/*               type="checkbox"*/}
                     {/*               checked={saveOrUpdateThirdPartyAddress}*/}
                     {/*               onChange={() => setSaveOrUpdateThirdPartyAddress(!saveOrUpdateThirdPartyAddress)}*/}
                     {/*            />*/}
                     {/*         </Col>*/}
                     {/*         <Col xs="4" className="fw-bold">*/}
                     {/*            {addressSelectValue.label === "--- Other ---"*/}
                     {/*               ? "Save Third Party Billing Information"*/}
                     {/*               : "Update Third Party Billing Information"}*/}
                     {/*         </Col>*/}
                     {/*      </Row>*/}
                     {/*   )*/}
                     {/*   : null}*/}

                  </Fragment>
               )
               : null}
         </div>
      </DesktopContainer>
   );
}
